import {connect} from 'pwa-helpers';
import {LitElement, html, css, svg} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../store';

@customElement('toolbar-button')
export class ToolbarButton extends LitElement {

	static styles = css`
		button {
			display: flex;
			gap: var(--small-padding);
			align-items: center;
			justify-content: center;
			flex-direction: row;

			font-family: var(--font-family-light);
			font-size: var(--font-size-widget);
			color: var(--color-widget-text);
			height: var(--nav-button-height);
			width: var(--nav-button-height);
			letter-spacing: 1px;
			background-color: var(--color-widget-background);
			border: none;
			cursor: pointer;
			line-height: 0;
			transition: background-color 0.4s ease-out, color 0.4s ease-out;
		}
		button:hover {
			background-color: var(--color-widget-background-hover);
		}
		button.disabled {
			pointer-events: none;
			color: var(--color-widget-text-disabled);
		}
		button.active {
			background-color: var(--color-widget-background-selected);
		}
		button.withLabel {
			width: auto;
			padding-left: var(--padding);
			padding-right: var(--padding);
		}
		.label {
			display: inline-block;
			color: var(--color-widget-text);
		}
		.disabled .label {
			color: var(--color-widget-text-disabled);
		}
		.icon {
			display: inline-block;
			max-width: 20px;
		}
		.disabled .icon {
			color: var(--color-widget-text-disabled);
		}
	`;

	@property({type: Object})
	icon = null;

	@property({type: String})
	label = '';

	@property({type: Function})
	action = null;

	@property({type: Boolean})
	disabled = false;

	@property({type: Boolean})
	active = false;

	render() {
		return html`
			<button @click=${this.action} class="settings ${classMap({active: this.active, disabled: this.disabled, withLabel: this.label !== ''})}" title="${this.label}">
				${when(this.label !== '', () => html`<span class="label">${this.label}</span>`)}
				${when(this.icon !== null, () => html`<span class="icon">${this.icon}</span>`)}
			</button>
		`;
	}
}
